import { FC, memo } from 'react'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import ChevronBackward from '~icons/material-symbols/chevron-backward'
import { useTranslation } from '@crew/modules/i18n'

export type AiAssistantThreadHeaderProps = {
  onBackButtonClick: () => void // 戻るボタンがクリックされたときのコールバック関数
}

/**
 * スレッド表示形式のヘッダ
 */
export const AiAssistantThreadHeader: FC<AiAssistantThreadHeaderProps> = memo(
  (props) => {
    const { t } = useTranslation()
    return (
      <div
        className="flex items-center shrink-0 h-10 px-2 gap-2 crew-link"
        onClick={props.onBackButtonClick}
      >
        {/* 戻るボタン */}
        <CrewButton
          icon={<ChevronBackward width={20} height={20} color="currentColor" />}
          stylingMode="text"
          type="normal"
          size="sm"
        />
        <span className="grow font-bold line-clamp-1 break-all">
          {t('label.backToThreadList')}
        </span>
      </div>
    )
  }
)
